import { AgentId } from '@components/Copilot/types';

export const REDUCED_CONTEXT_MSG = 'This session was initiated with limited context due to the ticket containing a large volume of data.';

export const defaultSessionData = { defaultPrompts: [], useFallbackQueries: false };

export const COPILOT_PANEL_WIDTH = 440;

export const QUERY_HISTORY_DETECTIVE_CONFIRM_DIALOG_CONFIG = {
  title: 'Discard investigation?',
  body: 'Closing this chat will discard the current investigation.',
};

export const copilotConfig = {
  [AgentId.REMEDIATION_COPILOT]: {
    title: 'Remediation ZAgent',
    placeholderText: 'Share what you’d like to remediate...',
    defaultPrompts: [
      'What is the recommended patch or software update for this vulnerability?',
      'What are the recommended steps to remediate this misconfiguration?',
      'Can you recommend configuration best practices to avoid similar issues in the future?',
      'What is the potential risk impact if this vulnerability remains unaddressed?',
      'Can you prioritize fixes based on the criticality of assets affected in this finding?',
      'Can you provide step-by-step instructions to implement the recommended fix?',
      'How can I validate that this vulnerability has been successfully remediated?',
      'What are the common post-remediation testing procedures for this type of issue?',
      'Can you summarize this remediation plan to include it in the ticket?',
      'What compensating controls can be implemented until a patch is available?',
      'Can you provide general mitigation strategies for this type of vulnerability?',
      'What lessons can we apply from this finding to avoid similar issues in the future?',
    ],
    getConfirmationText: (isSummary: boolean) =>
      `You’re about to close the Remediation ZAgent chat, but the insights haven't been ${
        isSummary ? 'saved to the Ticket Fixes tab' : 'summarized nor saved to the Ticket Fixes tab'
      }. If you proceed, the chat will be closed and insights will be lost.`,
  },
  [AgentId.AQL_AGENT]: {
    title: 'AQL ZAgent',
  },
  [AgentId.ENTITY_MAPPING_AGENT]: {
    stateUpdate: {
      enabled: true,
      text: 'Disregard current mapping when using mapping ZAgent',
    },
    title: 'Mapping ZAgent',
    placeholderText: 'How can I help you map this data?',
    defaultPrompts: [/* 'Map all', */ 'Map to Asset', 'Map to Finding', 'Show me top 10 results for asset type'], // TODO pass from BE,
    getConfirmationText: () =>
      `You are about to close the Mapping ZAgent. If you proceed the insights and context of this conversation will be lost`,
  },
  [AgentId.INCIDENT_INVESTIGATION_ASSISTANT]: {
    title: 'Investigation Assistant',
    placeholderText: 'Ask about this incident investigation...',
    defaultPrompts: [
      'What did the investigation conclude and why?',
      'Which leads support a real threat?',
      'Show me the involved assets and users',
    ],
    getConfirmationText: () =>
      `You are about to close the Investigation Assistant. If you proceed the insights and context of this conversation will be lost`,
  },
  [AgentId.INCIDENT_RULE_GENERATION_AGENT]: {
    title: 'Incident Rules ZAgent',
    placeholderText: 'How can I help you with this incident rule?',
    getConfirmationText: () =>
      `You are about to close the Incident Rules ZAgent. If you proceed the insights and context of this conversation will be lost`,
  },
  [AgentId.QUERY_HISTORY_DETECTIVE_AGENT]: {
    title: 'Historical Widget ZAgent',
    placeholderText: 'Ask about this widget’s data...',
    defaultPrompts: [
      'Why did my metric spike by 30% in this date range?',
      'Investigate the steady decline in my metric',
      "What's causing this anomaly in my data?",
    ],
    getConfirmationText: () =>
      `You are about to close the Historical Widget ZAgent. If you proceed the insights and context of this conversation will be lost`,
  },
} as const;
